import React from "react";
import { Route, Routes, Outlet } from "react-router-dom";
import { IntlProvider } from "react-intl";
import styled from "styled-components";
import GlobalStyle from "./globalStyles";
import Login from "./components/Auth/Login";
import Register from "./components/Auth/Register";
import ForgotPassword from "./components/Auth/ForgotPassword";
import LandingPage from "./components/LandingPage";
import { getMessagesForLocale, useLanguage } from "./context/LanguageContext";
import ResetPassword from "./components/Auth/ResetPassword";
import RequireAuth from "./components/Auth/RequireAuth";
import PersistLogin from "./components/Auth/PersistLogin";
import Requests from "./components/Requests";
import { DataProvider } from "./context/DataContext";
import RequestDetails from "./components/RequestDetails";
import Missing from "./components/Missing";
import TopBar from "./components/TopBar";
import BottomBar from "./components/BottomBar/BottomBar";

/*
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <RequireAuth>
        <LandingPage />
      </RequireAuth>
    ),
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password/:token",
    element: <ResetPassword />,
  },
]);
*/

const AppContainer = styled.div`
  height: 100vh;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

function AuthLayout() {
  return (
    <AppContainer>
      <TopBar />
      <Outlet />
      <BottomBar />
    </AppContainer>
  );
}

function AppRoutes() {
  return (
    <>
      <GlobalStyle />
      <main>
        <Routes>
          <Route path="/">
            {/* public routes */}
            <Route element={<AuthLayout />}>
              <Route path="login" element={<Login />} />
              <Route path="register/:token" element={<Register />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
              <Route path="reset-password/:token" element={<ResetPassword />} />
            </Route>

            {/* we want to protect these routes */}
            <Route element={<PersistLogin />}>
              <Route element={<RequireAuth />}>
                <Route path="/" element={<LandingPage />}>
                  <Route path="/requests" element={<Requests />} />
                  <Route path="/request/:id" element={<RequestDetails />} />
                </Route>
              </Route>
            </Route>

            {/* catch all */}
            <Route path="*" element={<Missing />} />
          </Route>
        </Routes>
      </main>
    </>
  );
}

function App() {
  const { locale } = useLanguage();

  return (
    <IntlProvider locale={locale} messages={getMessagesForLocale(locale)}>
      <DataProvider>
        <AppRoutes />
        {/* <RouterProvider router={router} /> */}
      </DataProvider>
    </IntlProvider>
  );
}

export default App;
